/* eslint-disable react/jsx-props-no-spreading */
import type { UseComboboxPropGetters } from 'downshift';
import type { FunctionComponent } from 'react';
import type { CommandPaletteSearchFEResult } from '../../../shared/CommandPalette/types';
import type { CommandPaletteSectionHeading } from './types';
import styles from './Results.module.less';

type Props = ReturnType<UseComboboxPropGetters<CommandPaletteSearchFEResult>['getMenuProps']> & {
  sectionHeading: CommandPaletteSectionHeading;
};

/**
 * Container for a "section" of search results. This is meant
 * to have `getMenuProps` spread onto it. It will provide the heading
 * for this section, along with the results (as children, so that they
 * can each have `getItemProps` spread onto them in the parent component).
 */
const Results: FunctionComponent<Props> = ({ children, sectionHeading, ...props }) => (
  <div className={styles.results}>
    <div className={styles.resultsSectionHeading}>
      {sectionHeading}
    </div>
    <ul {...props} className={styles.resultsList}>
      {children}
    </ul>
  </div>
);

export default Results;
